function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-669.000000, -210.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  transform: "translate(669.000000, 210.000000)"
}, React.createElement("g", null, React.createElement("polygon", {
  points: "2.81142857 11.6228571 0.445714286 11.6228571 0.445714286 9.25714286"
}), React.createElement("polygon", {
  transform: "translate(6.360218, 5.708711) rotate(135.000000) translate(-6.360218, -5.708711) ",
  points: "0.784283159 4.03596973 11.9361534 4.03596973 11.9361534 7.38145193 0.784283159 7.38145193"
}), React.createElement("polygon", {
  points: "0.445714286 13.2 0.445714286 12.4114286 8.54857143 12.4114286 8.54857143 13.2"
})))));

const SvgEditWhiteIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "12px",
  height: "14px",
  viewBox: "0 0 12 14",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgEditWhiteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-white-icon.9859a4ef.svg";
export { ForwardRef as ReactComponent };